export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0004.19ca889e.webp";